<template>
    <section class="new-members">
        <h2 class="section-subtitle">Moje přihlášky</h2>

        <v-row>
            <v-col cols="16" offset="0" sm="10" offset-sm="4">
                <v-card flat>
                    <div class="table-responsive">
                        <v-data-table
                            :headers="headers"
                            :items="requests"
                            must-sort
                            hide-default-footer
                            light
                            class="transparent"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td class="v-data-table__mobile-row">
                                        <router-link :to="{ name: 'teamDetail', params: { id: props.item.team.id } }">
                                            <team-blazon-view :settings="props.item.team.blazon" class="small" />
                                            <span style="left: 10px;">{{ props.item.team.name }}</span>
                                        </router-link>
                                    </td>
                                    <td class="v-data-table__mobile-row">
                                        {{ props.item.created | formatToday }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-card>
            </v-col>
        </v-row>

    </section>
</template>

<script>
    import TeamBlazonView from '../TeamBlazon/TeamBlazonView';

    export default {
        name: 'MyRequests',
        components: { TeamBlazonView },
        data () {
            return {
                headers: [
                    {
                        text: 'Tým',
                        value: 'name',
                    },
                    {
                        text: 'Vytvořeno',
                        value: 'created',
                    },
                ],
            };
        },
        props: {
            requests: {
                type: Array,
                required: true,
            },
        },
    }
</script>
